import { render, staticRenderFns } from "./TypeAssetApp.vue?vue&type=template&id=8f8a63dc&scoped=true"
import script from "./TypeAssetApp.vue?vue&type=script&lang=js"
export * from "./TypeAssetApp.vue?vue&type=script&lang=js"
import style0 from "./TypeAssetApp.vue?vue&type=style&index=0&id=8f8a63dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8a63dc",
  null
  
)

export default component.exports